import {
  CalendarIcon,
  GossipIcon,
  MarketIcon,
  NewsItemIcon,
  SuggestionIcon
} from '@/assets';
import { PushCategorySection } from '@/features/profile-setting/types/pushCategory';
import type { SVGComponent } from '@/types';

export const PushCategorySectionRecord: Record<string, PushCategorySection> = {
  'e6e0808d-2be7-492c-baf2-7d131fe281e2': PushCategorySection.Posts, // Neue Funks
  '46ddce29-97b7-4145-b58e-efcd775fb366': PushCategorySection.Posts, // Dorfhelfer
  'b396564d-e9d6-4d62-baf6-a29798343d11': PushCategorySection.Posts, // Plausch
  '6286fe3e-a9e7-477a-ab4d-536e21c270ba': PushCategorySection.Posts, // News
  '7c6f99c3-8cb6-4627-aed7-2a222f150764': PushCategorySection.Posts, // Blaulicht
  '2cbe23b6-cf99-4463-a0a1-40015485e67b': PushCategorySection.Posts, // Biete
  'cdd931b3-601f-4bb5-9490-650046db0b16': PushCategorySection.Posts, // Suche
  '6e36fe4c-385f-42c5-9350-1364f1561946': PushCategorySection.Posts, // Events
  'db92329f-8ee5-4abd-b2b6-113c4a6a3789': PushCategorySection.Posts, // Sags uns
  '55afb150-b8ff-46f8-acd6-e68e14cc5992': PushCategorySection.Posts, // KATWARN
  '839180a0-ce06-4068-b60f-6e44840db096': PushCategorySection.Groups, // Gruppen
  '08b0d55f-1af0-4596-a377-9e7bb5a4d790': PushCategorySection.Groups, // Änderung in Gruppenmitgliedschaft
  '37b870c1-20aa-4769-8956-99d6538b2041': PushCategorySection.Groups, // Mitgliedsanfrage
  '8ba71617-d2d3-4dc1-8802-3a78d53d54e3': PushCategorySection.Miscellaneous, // Private Chatnachrichten
  '5fb2d8d1-bdab-434c-bc4e-f2447f63100a': PushCategorySection.Miscellaneous, // Neuer privater Chat
  '0d4129f6-dbf4-11e7-9296-cec278b6b50a': PushCategorySection.Miscellaneous, // Antwort auf meine Funks
  '0d412c8a-dbf4-11e7-9296-cec278b6b50a': PushCategorySection.Miscellaneous, // Antwort auf meine Kommentare
  '135e3678-215e-4a87-bb30-ea11ff501649': PushCategorySection.Miscellaneous, // Kommentare zu Beiträgen meiner Organisation
  '15a41f0c-41f2-4b41-896c-507c9e2fc54b': PushCategorySection.Miscellaneous // Aufnahme in Organisation
};

export const PushCategoryIconRecord: Record<string, SVGComponent> = {
  'b396564d-e9d6-4d62-baf6-a29798343d11': GossipIcon,
  '6e36fe4c-385f-42c5-9350-1364f1561946': CalendarIcon,
  '6286fe3e-a9e7-477a-ab4d-536e21c270ba': NewsItemIcon,
  '7c6f99c3-8cb6-4627-aed7-2a222f150764': NewsItemIcon,
  '2cbe23b6-cf99-4463-a0a1-40015485e67b': MarketIcon,
  'cdd931b3-601f-4bb5-9490-650046db0b16': MarketIcon,
  'db92329f-8ee5-4abd-b2b6-113c4a6a3789': SuggestionIcon,
  '46ddce29-97b7-4145-b58e-efcd775fb366': GossipIcon
};
